<template>
  <a
    :href="link.url"
    :class="[link.active === 'true' ? 'active' : '']"
    :aria-label="`navigate to ${link.title} page`"
    >{{ link.title }}</a
  >
</template>


<script>
export default {
  props: {
    link: { type: Object },
  },
}
</script>